import { TextField, TextFieldProps } from "@mui/material";
import { textFieldDefaultProps } from "./TextFieldDefaultProps";

export function DisabledTextField({ ...props }: Omit<TextFieldProps, "size" | "disabled">) {
  return <TextField {...props} {...textFieldDefaultProps} disabled />;
}
